import { render, staticRenderFns } from "./PlatformOverview.vue?vue&type=template&id=fb0362d6&scoped=true&"
import script from "./PlatformOverview.vue?vue&type=script&lang=js&"
export * from "./PlatformOverview.vue?vue&type=script&lang=js&"
import style0 from "./PlatformOverview.vue?vue&type=style&index=0&id=fb0362d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0362d6",
  null
  
)

export default component.exports